$('.burger-btn').click(function () {
	$(this).toggleClass('burger-btn_close');
});
$('.burger-btn_menu').click(function () {
	$('.page').toggleClass('page_overflow');
	$('.header__menu').toggleClass('header__menu_open');
});



// WEBPACK FOOTER //
// ./_dev/blocks/burger-btn/burger-btn.js